import { motion } from "framer-motion";
import { Download, HardDrive, Monitor, FileBox, Layers } from "lucide-react";

const META = [
  { icon: Layers, label: "EDITION", value: "IPO INTELLIGENCE" },
  { icon: FileBox, label: "VERSION", value: "V1.0 — OPERATION BLUE" },
  { icon: Monitor, label: "PLATFORM", value: "WINDOWS 10 / 11 — 64 BIT" },
  { icon: HardDrive, label: "PACKAGE", value: "YIIS-100-SETUP.EXE" },
];

export const DownloadSection = ({ downloads, onDownload, downloadAvailable }) => {
  const countLabel = downloads === null ? "— — —" : downloads.toLocaleString("en-US");

  return (
    <section id="download" className="py-24 md:py-32 border-t border-border px-6 md:px-12" data-testid="download-section">
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground mb-8">
            Deployment
          </div>
          <h2 className="font-display font-semibold tracking-tight [word-spacing:0.1em] leading-[0.95] text-4xl sm:text-5xl md:text-7xl mb-12" data-testid="download-heading">
            GET <span className="text-accent">YIIS-100</span>
            <br />
            ON YOUR DESK.
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-7 flex flex-col gap-6">
              <button
                onClick={onDownload}
                disabled={downloadAvailable !== true}
                data-testid="download-section-button"
                className="group w-fit flex items-center gap-4 px-10 py-6 bg-accent text-accent-foreground font-mono text-base tracking-[0.15em] uppercase font-bold hover:bg-foreground hover:text-background transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-accent disabled:hover:text-accent-foreground"
              >
                <Download size={20} className="group-hover:translate-y-1 transition-transform duration-300" />
                {downloadAvailable === null ? "Connecting to download service..." : downloadAvailable ? "Download Installer" : "Installer unavailable"}
              </button>
              <div className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground" data-testid="download-section-counter">
                Total downloads to date —{" "}
                <span className="text-foreground font-bold tabular-nums">[ {countLabel} ]</span>
              </div>
            </div>

            <div className="lg:col-span-5 border border-border divide-y divide-border" data-testid="download-meta-table">
              {META.map(({ icon: Icon, label, value }) => (
                <div key={label} className="flex items-center gap-4 px-5 py-4">
                  <Icon size={16} className="text-accent shrink-0" />
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground w-24">
                    {label}
                  </span>
                  <span className="font-mono text-xs tracking-[0.1em]">
                    {label === "PACKAGE" && downloadAvailable === false ? "PENDING RELEASE" : value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
